/* eslint-disable max-lines */

export const enum RequestMethod {
  GET = 'GET',
  POST = 'POST',
  PUT = 'PUT',
  DELETE = 'DELETE',
  HEAD = 'HEAD',
  OPTIONS = 'OPTIONS',
}

export const enum PLAN_TYPES {
  PURCHASE = 'purchase',
  UPSELL = 'upsell',
  ONE_TIME = 'one_time',
}

export const enum PLAN_TAGS {
  CANCEL = 'cancel',
  NO_TAX = 'no_tax',
  UPSELL = 'upsell',
  US = 'us',
}

export const enum MediaBreakpoint {
  MIN_PHONE = 321,
  MEDIUM_PHONE = 360,
  MAX_PHONE = 415,
  SALES_SCREEN_MAX_PHONE = 431,
  SALES_SCREEN_MIN_PHONE = 430,
  TABLET = 520,
  PHONE_WITH_390_MIN = 390,
  QUESTIONS_DESKTOP = 600,
  DESKTOP = 1024,
}

export const enum StripeFieldName {
  NAME = 'name',
  NUMBER = 'cardNumber',
  EXPIRY = 'cardExpiry',
  CVC = 'cardCvc',
  EMAIL = 'email',
}

export const APP_NAME = 'stylio'

export const EMAIL_REGEXP = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const enum LoginMethod {
  EMAIL = 'email',
  GOOGLE = 'google',
  FACEBOOK = 'facebook',
  APPLE = 'apple',
}

export const enum FirebaseSignUpErrorCode {
  EMAIL_EXISTS = 'auth/email-already-in-use',
}

export const AMPLITUDE_API_KEY = '0402c092c27fdeb1ba35ef1865c1f16a'

export const enum ValidationText {
  EMAIL_EXISTS = 'account.accountAlreadyExist',
  INVALID_EMAIL = 'onboarding.email.validation',
  INVALID_EMAIL_VARIANT_2 = 'Please, check email address. It looks like there might be a typo',
  EMPTY_EMAIL_ERROR = 'Please, provide your email so we can send you the style plan.',
  SHORT_PASSWORD = 'account.shortPassword',
  WRONG_CONFIRMATION_PASSWORD = 'account.notEqualPassword',
  WRONG_PASSWORD = 'The password you entered is incorrect',
  WRONG_EMAIL = 'The email you entered is incorrect',
  INVALID_TEXT = `Your input doesn't look valid. Please, check`,
}

export const enum Color {
  ERROR_RGB = '255, 97, 97',
  PRIMARY_TEXT_RGB = '74, 53, 50',
  ERROR = '#FF6161',
  ERROR_2 = '#FF2121',
  BEIGE = '#FFF5E9',
  BEIGE_ALTERNATIVE = '#F7F6F1',
  WHITE = '#FFFFFF',
  BROWNISH_GRAY = '#B0A099',
  PRIMARY_TEXT = '#4A3532',
  MEDIUM_GREEN = '#35B43F',
  YELLOW_LIGHT = '#FFF192',
  LEMON_YELLOW = '#EAFF7D',
  PURPLE = '#7879F1',
  BLACK = '#000',
  DARK_VIOLET = '#4A23A5',
  DARK_PURPLE = '#854eb3',
  GREY_TEXT = '#848484',
  VIOLET_ALTERNATIVE = '#F1F0FF',
  VIOLET_SECONDARY = '#978FFF',
  APPLE = '#34B340',
  TEXT_SECONDARY = '#616161',
  RAISIN_BLACK = '#2C201F',
  GREY = '#F3F3F3',
  SHADOW_GREY = '#F7F7F7',
  TERTIARY = '#FF5600',
  OUTLINE = '#BDBDBD',
}

export const enum TimeInterval {
  DAY = 'day',
  WEEK = 'week',
  MONTH = 'month',
  YEAR = 'year',
}

export const enum EventLoggerInstanceName {
  GIA = 'gia-amplitude',
  AMPLITUDE = 'amplitude',
  RUDDERSTACK = 'rudderstack',
  USER_FLOW_TRACKER = 'user-flow-tracker',
}

export const enum PlatformOS {
  ANDROID = 'Android',
  IOS = 'iOS',
  UNKNOWN = 'unknown',
}

export const enum AppWithInAppBrowser {
  FACEBOOK = 'facebook',
  INSTAGRAM = 'instagram',
}

export const enum PagePath {
  LOCALHOST = 'localhost',
  TUTORIAL = 'tutorial',
  SUBSCRIPTIONS = 'subscriptions',
}

export const enum AnswerKey {
  TALL_FASHION_NUMBER_IN = 'tall_fashion_number_in',
  TALL_FASHION_NUMBER_FT = 'tall_fashion_number_ft',
  TALL_FASHION_NUMBER_CM = 'tall_fashion_number_cm',
  TALL_FASHION_UNIT = 'tall_fashion_unit',
  WEIGHT_FASHION_NUMBER = 'weight_fashion_number',
  WEIGHT_FASHION_UNIT = 'weight_fashion_unit',
  STYLE_GOAL_FASHION = 'style_goal_fashion',
  BODY_SHAPE_FASHION = 'body_shape_fashion',
  REASON_FASHION = 'reason_fashion',
  LIFESTYLE_FASHION = 'lifestyle_fashion',
  AGE_FASHION = 'age_fashion',
  AGE = 'age',
  STYLIO_TO_HELP = 'stylio_to_help',
  OUTFIT_STRUGGLES = 'outfit_struggles',
  BODY_SHAPE = 'body_shape',
  BODY_SHAPE_SNRS = 'body_shape_snrs',
  BODY_SHAPE_SNRS_2 = 'body_shape_snrs2',
  STYLE_MOST_MATTERS = 'style_most_matters',
  BRAND = 'brand',
  SEASON_TYPE = 'season_type',
  STYLES_FEEL_LIKE_YOU = 'styles_feel_like_you',
}

export const USER_ANSWER_TO_MARKUP_MAP: { [key: string]: string } = {}

export const STYLIO_1_COHORT = 'stylio_1'
export const STYLIO_PLUS_COHORT = 'stylio_plus'
export const STYLIO_SNRS_COHORT = 'stylio_snrs'
export const STYLIO_SNRS_2_COHORT = 'stylio_snrs2'
export const STYLIO_SNRS_IO_COHORT = 'stylio_snrs_io'
export const STYLIO_CAPSULE = 'stylio_capsule'
export const STYLIO_CAPSULE2 = 'stylio_capsule2'
export const STYLIO_CAPSULE3 = 'stylio_capsule3'
export const STYLIO_CAPSULE_IO = 'stylio_capsule_io'
export const STYLIO_CAPSEN = 'stylio_capsen'
export const STYLIO_CAPMOMS = 'stylio_capmoms'
export const STYLIO_CMP = 'stylio_cmp'
export const STYLIO_CMP2 = 'stylio_cmp2'
export const STYLIO_ARCH = 'stylio_arch'
export const STYLIO_ARCH_IO = 'stylio_arch_io'
export const STYLIO_HUSAP = 'stylio_husap'
export const STYLIO_CAPMOMS4 = 'stylio_capmoms4'
export const STYLIO_CAPSULE_61 = 'stylio_capsule_61'
export const STYLIO_CAPSULE_71 = 'stylio_capsule_71'
export const STYLIO_CAPSULE_81 = 'stylio_capsule_81'
export const STYLIO_ARCH_61 = 'stylio_arch_61'
export const STYLIO_ARCH_71 = 'stylio_arch_71'
export const STYLIO_ARCH_81 = 'stylio_arch_81'
export const DEFAULT_COHORT = STYLIO_1_COHORT

export const ACTIVE_COHORTS = [
  STYLIO_1_COHORT,
  STYLIO_SNRS_COHORT,
  STYLIO_SNRS_IO_COHORT,
  STYLIO_CAPSULE,
  STYLIO_CAPSULE3,
  STYLIO_CAPSULE_IO,
  STYLIO_CAPSEN,
  STYLIO_CAPMOMS,
  STYLIO_CMP,
  STYLIO_CMP2,
  STYLIO_ARCH,
  STYLIO_ARCH_IO,
  STYLIO_HUSAP,
  STYLIO_CAPSULE_61,
  STYLIO_CAPSULE_71,
  STYLIO_CAPSULE_81,
  STYLIO_ARCH_61,
  STYLIO_ARCH_71,
  STYLIO_ARCH_81,
]

export const PAYPAL_DISABLED_COHORTS: string[] = [
  STYLIO_SNRS_2_COHORT,
  STYLIO_CAPSULE2,
]

export const THEMES = {
  VARIANT_FASHION: 'variant_fashion',
  BASIC: 'basic',
}

export const enum CurrentEnvironment {
  DEV = 'dev',
  STAGE = 'stage',
  PROD = 'prod',
  DEV02 = 'dev02',
  STAGE_QA = 'stage-qa',
}

export const PRIVACY_POLICY_LINKS = {
  [CurrentEnvironment.DEV]: 'https://ws-stylio.supernove8.com/privacy_policy/',
  [CurrentEnvironment.STAGE]: 'https://ws-stylio.meganove8.com/privacy_policy/',
  [CurrentEnvironment.PROD]: 'https://quiz.stylio.fashion/privacy_policy/',
  [CurrentEnvironment.STAGE_QA]:
    'https://ws-stylio-qa.meganove8.com/privacy_policy/',
  [CurrentEnvironment.DEV02]:
    'https://ws-stylio-02.supernove8.com/privacy_policy/',
}

export const TERMS_OF_USE_LINKS = {
  [CurrentEnvironment.DEV]: 'https://ws-stylio.supernove8.com/terms_of_use/',
  [CurrentEnvironment.STAGE]: 'https://ws-stylio.meganove8.com/terms_of_use/',
  [CurrentEnvironment.PROD]: 'https://quiz.stylio.fashion/terms_of_use/',
  [CurrentEnvironment.STAGE_QA]:
    'https://ws-stylio-qa.meganove8.com/terms_of_use/',
  [CurrentEnvironment.DEV02]:
    'https://ws-stylio-02.supernove8.com/terms_of_use/',
}

export const CONTACT_US_LINKS = {
  [CurrentEnvironment.DEV]:
    'https://ws-account.supernove8.com/stylio/contact-us',
  [CurrentEnvironment.STAGE_QA]:
    'https://ws-account-qa.meganove8.com/stylio/contact-us',
  [CurrentEnvironment.STAGE]:
    'https://ws-account.meganove8.com/stylio/contact-us',
  [CurrentEnvironment.PROD]: 'https://account.nove8.com/stylio/contact-us',
  [CurrentEnvironment.DEV02]:
    'https://ws-account-02.supernove8.com/stylio/contact-us',
}

export const ENV_MAP = {
  [CurrentEnvironment.DEV]: 'ws-stylio.supernove8.com',
  [CurrentEnvironment.STAGE]: 'ws-stylio.meganove8.com',
  [CurrentEnvironment.PROD]: 'quiz.stylio.fashion',
  [CurrentEnvironment.STAGE_QA]: 'ws-stylio-qa.meganove8.com',
  [CurrentEnvironment.DEV02]: 'ws-stylio-02.supernove8.com',
}

export const NOVE8_SUBSCRIPTIONS_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'subscriptions.supernove8.com',
  [CurrentEnvironment.STAGE]: 'subscriptions.meganove8.com',
  [CurrentEnvironment.PROD]: 'subscriptions.nove8.com',
  [CurrentEnvironment.DEV02]: 'subscriptions-dev02.supernove8.com',
  [CurrentEnvironment.STAGE_QA]: 'subscriptions-qa.meganove8.com',
}

export const NOVE8_SUBSCRIPTIONS_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'VnRTLf6D5hQHNeee8',
  [CurrentEnvironment.STAGE]: 'Y2663QY9HhotROlk5iDaIAR58jaFkBMRw',
  [CurrentEnvironment.PROD]: 'T4mdUKu0bCF54xkAyb7HslwWLZKkJTVG1',
  [CurrentEnvironment.DEV02]: 'VnRTLf6D5hQHNeee8',
  [CurrentEnvironment.STAGE_QA]: 'QA7KdN3P9MqrstuVXYZ1234ABCDeFgHiJk',
}

export const STYLIO_TOOLS_API_LINKS = {
  [CurrentEnvironment.DEV]: 'https://stylio-tools.meganove8.com',
  [CurrentEnvironment.STAGE]: 'https://stylio-tools.meganove8.com',
  [CurrentEnvironment.STAGE_QA]: 'https://stylio-tools.meganove8.com',
  [CurrentEnvironment.DEV02]: 'https://stylio-tools.meganove8.com',
  [CurrentEnvironment.PROD]: 'https://stylio-tools.nove8.com',
}

export const COLOR_ANALYSIS_API_LINKS = {
  [CurrentEnvironment.DEV]: 'https://stage-assistant.nove8.com',
  [CurrentEnvironment.DEV02]: 'https://stage-assistant.nove8.com',
  [CurrentEnvironment.STAGE]: 'https://stage-assistant.nove8.com',
  [CurrentEnvironment.STAGE_QA]: 'https://stage-assistant.nove8.com',
  [CurrentEnvironment.PROD]: 'https://assistant.nove8.com',
}

export const COLOR_ANALYSIS_API_KEY_ENV_MAP = {
  [CurrentEnvironment.DEV]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.DEV02]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.STAGE]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.STAGE_QA]: 'ap-wsQlroFyQ7sdlaD3AYZuHT8P7K1tXfc4Ot',
  [CurrentEnvironment.PROD]: 'ap-wpM2uEz601jn8MWLc2es5iQ3MVPVgQ3aWb',
}

export const COLOR_ANALYSIS_REQUEST_TIMEOUT_MS = 30000

export const FACE_API_MODELS_URL = '/models/face-api'

export const CREATIVE_REQUEST_TIMEOUT_MS = 3000

export const NOVE8_WEBSITE_LINKS = {
  [CurrentEnvironment.DEV]: 'https://ws-account.supernove8.com/stylio/login',
  [CurrentEnvironment.DEV02]:
    'https://ws-account-02.supernove8.com/stylio/login',
  [CurrentEnvironment.STAGE]: 'https://ws-account.meganove8.com/stylio/login',
  [CurrentEnvironment.STAGE_QA]:
    'https://ws-account-qa.meganove8.com/stylio/login',
  [CurrentEnvironment.PROD]: 'https://account.nove8.com/stylio/login',
}

export const LANG_QUERY_PARAM = 'lang'
export const INITIAL_LANGUAGE = 'en'

export const LOCALES = {
  EN: 'en',
  ES: 'es',
  PT: 'pt',
  FR: 'fr',
  DE: 'de',
  IT: 'it',
}

export const SUPPORTED_LOCALES: string[] = [
  LOCALES.EN,
  LOCALES.ES,
  LOCALES.FR,
  LOCALES.PT,
  LOCALES.DE,
  LOCALES.IT,
]

export const enum FirebaseRemoteConfigKey {
  WEB_FUNNELS_CONFIG_FILE = 'web_funnels_config_file',
  ABTEST_WEB_2274_SNR_COPY_IMPR = 'abtest_web_2274_snr_copy_impr',
  ABTEST_WEB_67_APPLEPAY = 'abtest_web_67_applepay',
  ABTEST_WEB_78_OTP_UPSELL_IMPR = 'abtest_web_78_otp_upsell_impr',
  ABTEST_WEB_101_LOCATION_DETECTION = 'abtest_web_101_location_detection',
  ABTEST_WEB_303_PC_RECEIPT_UPSELL = 'abtest_web_303_pc_receipt_upsell',
  ABTEST_WEB_152_MOSSO = 'abtest_web_152_mosso',
  ABTEST_WEB_274_MOSSO = 'abtest_web_274_mosso',
  ABTEST_WEB_203_PERSONALISATION_IO = 'abtest_web_203_personalisation_io',
  ABTEST_WEB_151_BUNDLE = 'abtest_web_151_bundle',
  ABTEST_WEB_151_2_BUNDLE_CAPSULE = 'abtest_web_151_2_bundle_capsule',
  ABTEST_WEB_272_BUNDLE_CAPSULE_IO = 'abtest_web_272_bundle_capsule_io',
  ABTEST_WEB_134_SCAN = 'abtest_web_134_scan',
}

// TODO: replace with string const enum when first Growthbook test is added
// eslint-disable-next-line @typescript-eslint/naming-convention
export type GrowthbookKey = never

export const enum FirebaseRemoteConfigTestGroup {
  ABTEST_WEB_2274_B_COPY_IMPR = 'abtest_web_2274_b_copy_impr',
  ABTEST_WEB_67_B_AP_CHECKOUT = 'abtest_web_67_b_ap_checkout',
  ABTEST_WEB_67_C_AP_PAYWALL = 'abtest_web_67_c_ap_paywall',
  ABTEST_WEB_78_B_OTP_UPSELL_IMPR = 'abtest_web_78_b_otp_upsell_impr',
  ABTEST_WEB_101_B_LOCATION_DETECTION = 'abtest_web_101_b_location_detection',
  ABTEST_WEB_303_A_BASE_ONLY = 'abtest_web_303_a_base_only',
  ABTEST_WEB_303_B_WITH_UPSELL = 'abtest_web_303_b_with_upsell',
  ABTEST_WEB_152_A_DEFAULT = 'abtest_web_152_a_default',
  ABTEST_WEB_152_B_MOSSO = 'abtest_web_152_b_mosso',
  ABTEST_WEB_274_A_DEFAULT = 'abtest_web_274_a_default',
  ABTEST_WEB_274_B_MOSSO = 'abtest_web_274_b_mosso',
  ABTEST_WEB_203_A_DEFAULT = 'abtest_web_203_a_default',
  ABTEST_WEB_203_B_PERSONALISATION_IO = 'abtest_web_203_b_personalisation_io',
  ABTEST_WEB_151_A_DEFAULT = 'abtest_web_151_a_default',
  ABTEST_WEB_151_B_BUNDLE = 'abtest_web_151_b_bundle',
  ABTEST_WEB_151_2_A_DEFAULT = 'abtest_web_151_2_a_default',
  ABTEST_WEB_151_2_B_BUNDLE_CAPSULE = 'abtest_web_151_2_b_bundle_capsule',
  ABTEST_WEB_272_A_DEFAULT = 'abtest_web_272_a_default',
  ABTEST_WEB_272_B_BUNDLE_CAPSULE_IO = 'abtest_web_272_b_bundle_capsule_io',
  ABTEST_WEB_134_A_DEFAULT = 'abtest_web_134_a_default',
  ABTEST_WEB_134_B_SCAN = 'abtest_web_134_b_scan',
}

export const DEFAULT_WEB_FUNNELS_CONFIG_FILE = {
  signUpMethods: {
    chooseOtherMethodsShown: true,
    otherMethodsShown: {
      facebook: true,
      apple: true,
      google: true,
    },
  },
  paymentMethodsConfig: {
    paypalMethodShown: true,
    cardMethodShown: true,
    applePayMethodShown: true,
    googlePayMethodShown: true,
  },
  webappRedirectForAndroid: false,
  webappRedirectForIOS: false,
  vcEventLink: '',
  allRightsReservedYear: '2026',
  isAppLovin: false,
}

export const PDF_FASHION_BOOK_LINK =
  'https://cdn.stylio.fashion/Body_Type_guide.pdf'
export const NONE = 'none'

export const APPLOVIN_PET_AGILITY_EQUIPMENT_CATEGORY_ID = 1604
export const LOGO_IMAGE_URL =
  'https://cdn-prod-unified-content.gismart.xyz/ce453056408feaaf0121c2635933afeb5fcc36b3343ed429f386167d3bb09bbd/logo.png'

export const EYES_COLORS = {
  BROWN: 'Brown',
  BLUE: 'Blue',
  GREEN: 'Green',
  HAZEL: 'Hazel',
  GRAY: 'Gray',
  AMBER: 'Amber',
  LIGHT: 'Light',
  MEDIUM: 'Medium',
  DARK: 'Dark',
}

export const HAIR_COLORS = {
  BLONDE: 'Blonde',
  BROWN: 'Brown',
  LIGHT_BROWN: 'Light Brown',
  GRAY: 'Gray',
  BLACK: 'Black',
  RED: 'Red',
  BLONDE_LIGHT_BROWN: 'Blonde / light brown',
  MEDIUM_BROWN_RED: 'Medium brown / red',
  DARK_BROWN_BLACK: 'Dark brown / black',
  GRAY_SILVER: 'Gray / silver',
}

export const JEWELRY_TYPES = {
  GOLD: 'gold',
  SILVER: 'silver',
}

export const enum Season {
  SUMMER = 'summer',
  SPRING = 'spring',
  WINTER = 'winter',
  AUTUMN = 'autumn',
}

export const enum Concepts {
  ColorPalette = 'color_palette',
  SeniorBeauty = 'senior_beauty',
  PlusSize = 'plus_size',
  BusinessStyle = 'business_style',
  Default = 'default_flow',
  Capsule = 'capsule',
  Archetype = 'archetype',
  SituationalStyle = 'situational_style',
  BodyTypeStyle = 'body_type_style',
}

export const NEW_CONCEPTS = [
  Concepts.Archetype,
  Concepts.BodyTypeStyle,
  Concepts.Capsule,
  Concepts.SituationalStyle,
] as const

export const enum BodyType {
  APPLE = 'apple',
  PEAR = 'pear',
  HOURGLASS = 'hourglass',
  TRIANGLE = 'inverted_triangle',
  RECTANGLE = 'rectangle_shaped',
}

export const BODY_TYPE_KEY_MAP = {
  [BodyType.APPLE]: 'Apple',
  [BodyType.PEAR]: 'Pear',
  [BodyType.HOURGLASS]: 'Hourglass',
  [BodyType.TRIANGLE]: 'Inverted Triangle',
  [BodyType.RECTANGLE]: 'Rectangle',
}
